import { resolve } from 'core/utils/env';

export const REACTIONS_EMOJI_LS_KEY = 'reactions_cache_emoji';
export const REACTIONS_VOTING_LS_KEY = 'reactions_cache_voting';
export const REACTIONS_RATING_LS_KEY = 'reactions_cache_rating';

/**
 * Время на которое кешируем счетчик реакции.
 */
export const CACHE_MINUTES = resolve({
  'dev': 0.5,
  'staging': 0.5,
  '*': 3,
});

/**
 * Максимальный размер колличества реакций, которое может храниться в сторадже
 * @type {number}
 */
export const STORAGE_MAX_SIZE = resolve({
  'dev': 5,
  'staging': 5,
  '*': 25,
});

/**
 * Карта параметра `parent_type`, для запроса к API (POST /api/v2/reactions)
 *
 * ВАЖНО не ошибиться в нейминге Topic и Topics!
 */
export const PARENT_TYPE_MAP = {
  news: 'Topics::News',
  article: 'Topics::Article',
  gallery: 'Topic::Gallery',
  video: 'Topic::Video',
  game_compare: 'Topics::GameCompare',
  pair_compare: 'Topics::PairCompare',
  card: 'Topic::Card',
  horoscope: 'Topics::Horoscope',
  selection: 'Topics::Selection',
  ugc: 'Topics::UGC',
};
